export default "__VITE_ASSET__0d1188f9__"